module.exports = __webpack_public_path__ + "img/onboardingFormDefaultPhoto_es.bbfb5791.svg";